 <template>
  <div :class="['threePage']">
    <div
      :class="[
        'threeIconPng',
        threeTitShow ? 'imgAnimated imgFadeIn' : 'bgGray',
      ]"
    ></div>
    <div class="bottomThree"></div>
    <!-- 白底 + 边框  文字-->
    <div :class="['titHeader', 'threeAnimated']" v-if="threeTitShow">
      蓬勃崛起之势，<br />践行生态文明思想
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <!-- <h4 class="tit threeAnimated fadeInLeftBig" v-if="threeTitShow">
        蓬勃崛起之势，践行生态文明思想
      </h4> -->
      <p class="textMian animated delay fadeIn" v-if="threeTitShow">
        2019年4月，安徽省政府参事室“林长制调研组”一行莅临我院调研。对我院在“林长制”实施方案编制以及林长制信息化平台研发方面作出的成绩进行了充分的肯定，并对公司取得的成果进行了总结点评。
      </p>
    </div>
    <div class="bwBox" v-if="threeBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianThree.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', threeTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "threePage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      threeTitShow: false,
      pageThreeAction: false,
      threeBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/threeK001.jpg",
        },
        {
          imgUrl: "img/dhShare/threeK002.jpg",
        },
        {
          imgUrl: "img/dhShare/threeK003.jpg",
        },
        {
          imgUrl: "img/dhShare/threeK004.jpg",
        },
        {
          imgUrl: "img/dhShare/threeK005.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.threeTitShow = false;
      this.typePage = this.landscapeType;
    });
  },
  methods: {
    initPage() {
      this.pageThreeAction = true;
    },

    changeHue() {
      this.threeBtnShow = false;
      this.threeTitShow = true;
    },
    seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "2") {
        this.pageThreeAction = true;
      } else {
        this.pageThreeAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.threePage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideThree.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .twoAnimated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
  }
  .titHeader {
    top: 60px;
    right: -5px;
    border: 1px solid #06d22c;
    color: #06d22c;
    .circle {
      border: 1px solid #06d22c;
    }
  }
  .titBox {
    position: absolute;
    top: 40px;
    right: 45px;

    .textMian {
      width: 200px;
      position: absolute;
      left: -15px;
      top: 50px;
      font-size: 12px;
      color: #06d22c;
      text-align: justify;
      opacity: 0;
    }
  }

  .threeIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/threeIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    -webkit-filter: grayscale(100%);
    /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .bottomThree {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/bottomThree.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 12;
  }
  /** css3动画效果 **/

  .threeAnimated {
    animation: bounceInDown 2s forwards linear;
    /* Safari 和 Chrome */
  }
  .imgMainBox {
    position: absolute;
    bottom: 25px;
    left: 0;
    
    z-index: 999;
    width: 100%;
    display: none;
    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>